import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "skip-to-main-content",
  class: "create-request-page mb-6"
}
const _hoisted_2 = { class: "section container" }
const _hoisted_3 = { class: "columns is-variable" }
const _hoisted_4 = { class: "column is-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "is-uppercase is-size-5 has-text-weight-bold" }, " Request a public record ", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "block" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { "aria-live": "polite" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "document-upload" }
const _hoisted_14 = {
  key: 0,
  class: "document-upload__list"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Upload and attach files (optional)", -1)
const _hoisted_16 = {
  key: 0,
  class: "field"
}
const _hoisted_17 = {
  key: 0,
  class: "block"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "is-uppercase is-size-5 has-text-weight-bold" }, " Requester information ", -1)
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "columns is-variable" }
const _hoisted_21 = { class: "column" }
const _hoisted_22 = { class: "column is-3" }
const _hoisted_23 = { class: "column is-3" }
const _hoisted_24 = {
  key: 1,
  class: "block"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "is-uppercase is-size-5 has-text-weight-bold" }, " Your information ", -1)
const _hoisted_26 = { class: "columns is-variable" }
const _hoisted_27 = { class: "column" }
const _hoisted_28 = { class: "column is-3" }
const _hoisted_29 = { class: "column is-3" }
const _hoisted_30 = {
  key: 2,
  class: "block"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "is-size-5 has-text-weight-bold" }, " Terms and Conditions ", -1)
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_34 = { class: "field" }
const _hoisted_35 = {
  key: 3,
  class: "block"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", { class: "is-uppercase is-size-5 has-text-weight-bold" }, " Additional request information ", -1)
const _hoisted_37 = { class: "columns is-variable" }
const _hoisted_38 = { class: "column is-4" }
const _hoisted_39 = { class: "column is-4" }
const _hoisted_40 = { class: "field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "formatReceived"
}, " Format received ", -1)
const _hoisted_42 = { class: "control" }
const _hoisted_43 = { class: "select" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select", -1)
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "column is-4"
}
const _hoisted_47 = { class: "field" }
const _hoisted_48 = {
  class: "label",
  for: "visibility"
}
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "control" }
const _hoisted_51 = { class: "select" }
const _hoisted_52 = ["value", "selected"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_54 = { class: "block mt-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("p", null, "* Indicates required field")
], -1)
const _hoisted_56 = { class: "column is-4 is-offset-1" }
const _hoisted_57 = { class: "notification content" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h3", { class: "is-size-5" }, "Tips", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Don't put personal information, like your social security number in your public request. "),
  /*#__PURE__*/_createElementVNode("li", null, " If you don't know the name of the record, describe the information you believe is contained in it. ")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Are you sure? If you don't provide an email address, you won't be able to: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "receive automatic email updates about request status"),
    /*#__PURE__*/_createElementVNode("li", null, "see the request status here whenever you choose"),
    /*#__PURE__*/_createElementVNode("li", null, " easily download your documents from this site unless this request is made available to the general public "),
    /*#__PURE__*/_createElementVNode("li", null, " have your contact information automatically added to any future requests ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " If you wish to continue anyway without providing an email address, click \"Continue\". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomFieldsPreviewBanner = _resolveComponent("CustomFieldsPreviewBanner")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrEditor = _resolveComponent("NrEditor")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrButton = _resolveComponent("NrButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_RequestFieldInput = _resolveComponent("RequestFieldInput")!
  const _component_NrFormSelect = _resolveComponent("NrFormSelect")!
  const _component_NrDatepicker = _resolveComponent("NrDatepicker")!
  const _component_DocumentUploadModal = _resolveComponent("DocumentUploadModal")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.customFieldsPreview)
      ? (_openBlock(), _createBlock(_component_CustomFieldsPreviewBanner, {
          key: 0,
          onToggleModal: _ctx.togglePerspectiveModal,
          "preview-role": _ctx.currentUserPerspective
        }, null, 8, ["onToggleModal", "preview-role"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            innerHTML: _ctx.subheader,
            class: "content"
          }, null, 8, _hoisted_6),
          _createElementVNode("form", {
            class: "block",
            onSubmit: _cache[38] || (_cache[38] = _withModifiers(() => {}, ["prevent","stop"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_NrFormInput, {
                modelValue: _ctx.invisibleCaptcha,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invisibleCaptcha) = $event)),
                name: "description",
                class: "description",
                label: "Description"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_NrEditor, {
                  bulletList: "",
                  label: "Request description",
                  orderedList: "",
                  autofocus: "",
                  placeholder: "Enter your request - please include all information that could help fulfill this request.",
                  "aria-label": "Request description",
                  rows: 12,
                  "data-id": "request_text",
                  required: "",
                  modelValue: _ctx.requestText,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestText) = $event)),
                  onInput: _ctx.handleRequestInput,
                  onButtonTriggered: _ctx.addAccessibilityAlert
                }, null, 8, ["modelValue", "onInput", "onButtonTriggered"]),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keywordAlerts, (alert, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      innerHTML: alert,
                      key: `request-alert-${index}`,
                      class: "notification is-warning"
                    }, null, 8, _hoisted_10))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessibilityAlerts, (alert, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "visually-hidden",
                      innerHTML: alert,
                      key: `request-alert-${index}`
                    }, null, 8, _hoisted_11))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (!!_ctx.documentsToAdd.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentsToAdd, (document) => {
                          return (_openBlock(), _createBlock(_component_NrButton, {
                            variant: "minimal-neutral",
                            class: "has-icon document-upload__list-item",
                            "aria-label": `Remove document: ${document.title}`,
                            key: document.id,
                            onClick: _withModifiers(($event: any) => (_ctx.handleDocumentRemoveClick(document.url)), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(document.title), 1),
                              _createVNode(_component_NrIcon, {
                                name: "times",
                                class: "m-left-8"
                              })
                            ]),
                            _: 2
                          }, 1032, ["aria-label", "onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  (_ctx.isSignedIn && !_ctx.customFieldsPreview)
                    ? (_openBlock(), _createBlock(_component_NrButton, {
                        key: 1,
                        onClick: _withModifiers(_ctx.handleUploadModalClick, ["prevent"]),
                        variant: "filled-neutral"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Choose file(s) ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_NrTooltip, {
                        key: 2,
                        label: "Need to upload supporting documentation? If you have a NextRequest account for this agency, sign in to enable the upload button. Otherwise, finish making your request. You will be prompted to set up a your new user account which will allow you to upload any supporting documents on the request after it has been submitted."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NrButton, {
                            "aria-disabled": true,
                            variant: "filled-neutral"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Choose file(s) ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ])
              ]),
              (_ctx.showDepartments)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_NrSelect, {
                      label: "name",
                      placeholder: _ctx.departmentSelectionText,
                      modelValue: _ctx.selectedDepartments,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDepartments) = $event)),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleDepartmentSelectionEvent('input', $event))),
                      onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleDepartmentSelectionEvent('typing', $event))),
                      options: _ctx.departments,
                      required: !!_ctx.departmentRequired,
                      multiple: _ctx.multipleDeptSelection,
                      class: "department-select"
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(" Department" + _toDisplayString(_ctx.multipleDeptSelection ? 's' : ''), 1)
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue", "options", "required", "multiple"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestFields, (field) => {
                return (_openBlock(), _createBlock(_component_RequestFieldInput, {
                  definition: field.definition,
                  key: field.definition.id,
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  onOnValidate: _ctx.handleRequestFieldValid
                }, null, 8, ["definition", "modelValue", "onUpdate:modelValue", "onOnValidate"]))
              }), 128))
            ]),
            (_ctx.$can('read', 'staff_only_items'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_NrTooltip, {
                    position: "right",
                    label: "Personal information is visible only to staff by default,\n                      but requests are part of the public record and the\n                      information may be released in response to a public\n                      records request."
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Who can see this information? "),
                      _createVNode(_component_NrIcon, {
                        class: "info-circle-icon request-personal-information-icon",
                        name: "info-circle"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_NrFormInput, {
                    label: "Email",
                    type: "email",
                    name: "email",
                    modelValue: _ctx.requester.email,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requester.email) = $event)),
                    help: _ctx.emailNotice,
                    disabled: _ctx.emailDisabled,
                    validations: {
                    email: {
                      message: 'Email must be valid.',
                      validate: _ctx.validateEmailInput
                    }
                  },
                    autocomplete: "off",
                    onBlur: _ctx.handleEmailCheck,
                    onInput: _ctx.handleEmailInput,
                    onOnValidate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleRequesterInputValidState('email', $event)))
                  }, null, 8, ["modelValue", "help", "disabled", "validations", "onBlur", "onInput"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_NrFormInput, {
                      type: "checkbox",
                      label: "No email address available",
                      name: "no_email",
                      autocomplete: "off",
                      modelValue: _ctx.emailDisabled,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailDisabled) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_NrFormInput, {
                    label: "Name",
                    name: "name",
                    modelValue: _ctx.requester.name,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requester.name) = $event)),
                    disabled: _ctx.isRequesterFieldsDisabled,
                    required: !!_ctx.requesterRequired,
                    autocomplete: "off",
                    onOnValidate: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleRequesterInputValidState('name', $event)))
                  }, null, 8, ["modelValue", "disabled", "required"]),
                  _createVNode(_component_NrFormInput, {
                    label: "Phone",
                    name: "phone_number",
                    modelValue: _ctx.requester.phone,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requester.phone) = $event)),
                    disabled: _ctx.isRequesterFieldsDisabled,
                    required: !!_ctx.requesterRequired,
                    autocomplete: "off",
                    onOnValidate: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleRequesterInputValidState('phone', $event)))
                  }, null, 8, ["modelValue", "disabled", "required"]),
                  _createVNode(_component_NrFormInput, {
                    label: "Street address",
                    name: "street_address",
                    tag: "textarea",
                    modelValue: _ctx.requester.address,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requester.address) = $event)),
                    disabled: _ctx.isRequesterFieldsDisabled,
                    required: !!_ctx.requesterRequired,
                    autocomplete: "off",
                    onOnValidate: _cache[13] || (_cache[13] = ($event: any) => (
                    _ctx.handleRequesterInputValidState('address', $event)
                  ))
                  }, null, 8, ["modelValue", "disabled", "required"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_NrFormInput, {
                        label: "City",
                        name: "city",
                        modelValue: _ctx.requester.city,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requester.city) = $event)),
                        disabled: _ctx.isRequesterFieldsDisabled,
                        required: !!_ctx.requesterRequired,
                        autocomplete: "off",
                        onOnValidate: _cache[15] || (_cache[15] = ($event: any) => (
                        _ctx.handleRequesterInputValidState('city', $event)
                      ))
                      }, null, 8, ["modelValue", "disabled", "required"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_NrFormSelect, {
                        label: "State",
                        name: "state",
                        "include-blank": "",
                        modelValue: _ctx.requester.state,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.requester.state) = $event)),
                        disabled: _ctx.isRequesterFieldsDisabled,
                        required: !!_ctx.requesterRequired,
                        autocomplete: "off",
                        options: _ctx.usStates
                      }, null, 8, ["modelValue", "disabled", "required", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_NrFormInput, {
                        label: "Zip",
                        name: "zip",
                        modelValue: _ctx.requester.zip,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.requester.zip) = $event)),
                        disabled: _ctx.isRequesterFieldsDisabled,
                        required: !!_ctx.requesterRequired,
                        autocomplete: "off",
                        onOnValidate: _cache[18] || (_cache[18] = ($event: any) => (
                        _ctx.handleRequesterInputValidState('zip', $event)
                      ))
                      }, null, 8, ["modelValue", "disabled", "required"])
                    ])
                  ]),
                  _createVNode(_component_NrFormInput, {
                    label: "Company",
                    name: "company",
                    autocomplete: "off",
                    modelValue: _ctx.requester.company,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.requester.company) = $event)),
                    disabled: _ctx.isRequesterFieldsDisabled
                  }, null, 8, ["modelValue", "disabled"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_NrFormInput, {
                    label: "Email",
                    type: "email",
                    name: "email",
                    autocomplete: "on",
                    modelValue: _ctx.requester.email,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.requester.email) = $event)),
                    disabled: _ctx.isSignedIn && !_ctx.$can('read', 'staff_only_items'),
                    readonly: _ctx.isSignedIn && !_ctx.$can('read', 'staff_only_items'),
                    validations: {
                    email: {
                      message: 'Email must be valid.',
                      validate: _ctx.validateEmailInput
                    }
                  },
                    onOnValidate: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleRequesterInputValidState('email', $event)))
                  }, null, 8, ["modelValue", "disabled", "readonly", "validations"]),
                  _createVNode(_component_NrFormInput, {
                    label: "Name",
                    name: "name",
                    modelValue: _ctx.requester.name,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.requester.name) = $event)),
                    required: !!_ctx.requesterRequired,
                    autocomplete: "on",
                    onOnValidate: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleRequesterInputValidState('name', $event)))
                  }, null, 8, ["modelValue", "required"]),
                  _createVNode(_component_NrFormInput, {
                    label: "Phone",
                    name: "phone_number",
                    modelValue: _ctx.requester.phone,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.requester.phone) = $event)),
                    required: !!_ctx.requesterRequired,
                    autocomplete: "on",
                    onOnValidate: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleRequesterInputValidState('phone', $event)))
                  }, null, 8, ["modelValue", "required"]),
                  _createVNode(_component_NrFormInput, {
                    label: "Street address",
                    name: "street_address",
                    tag: "textarea",
                    modelValue: _ctx.requester.address,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.requester.address) = $event)),
                    required: !!_ctx.requesterRequired,
                    autocomplete: "on",
                    onOnValidate: _cache[27] || (_cache[27] = ($event: any) => (
                    _ctx.handleRequesterInputValidState('address', $event)
                  ))
                  }, null, 8, ["modelValue", "required"]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_NrFormInput, {
                        label: "City",
                        name: "city",
                        modelValue: _ctx.requester.city,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.requester.city) = $event)),
                        required: !!_ctx.requesterRequired,
                        autocomplete: "on",
                        onOnValidate: _cache[29] || (_cache[29] = ($event: any) => (
                        _ctx.handleRequesterInputValidState('city', $event)
                      ))
                      }, null, 8, ["modelValue", "required"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_NrFormSelect, {
                        label: "State",
                        name: "state",
                        "include-blank": "",
                        modelValue: _ctx.requester.state,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.requester.state) = $event)),
                        required: !!_ctx.requesterRequired,
                        options: _ctx.usStates,
                        autocomplete: "on"
                      }, null, 8, ["modelValue", "required", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_NrFormInput, {
                        label: "Zip",
                        name: "zip",
                        modelValue: _ctx.requester.zip,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.requester.zip) = $event)),
                        required: !!_ctx.requesterRequired,
                        autocomplete: "on",
                        onOnValidate: _cache[32] || (_cache[32] = ($event: any) => (
                        _ctx.handleRequesterInputValidState('zip', $event)
                      ))
                      }, null, 8, ["modelValue", "required"])
                    ])
                  ]),
                  _createVNode(_component_NrFormInput, {
                    label: "Company",
                    name: "company",
                    autocomplete: "on",
                    modelValue: _ctx.requester.company,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.requester.company) = $event))
                  }, null, 8, ["modelValue"])
                ])),
            (_ctx.termsAndConditionsRequired)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", {
                    class: "terms-and-conditions content",
                    innerHTML: _ctx.termsAndConditions
                  }, null, 8, _hoisted_32),
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_NrFormInput, {
                      type: "checkbox",
                      label: "I acknowledge the above terms and conditions.",
                      name: "terms",
                      required: "",
                      modelValue: _ctx.termsAndConditionsChecked,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.termsAndConditionsChecked) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
                _ctx.$can('update', 'Request') &&
                (!_ctx.customFieldsPreview || _ctx.currentUserPerspective == 'Staff')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_NrDatepicker, {
                        name: "date",
                        modelValue: _ctx.dateReceived,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.dateReceived) = $event)),
                        maxDate: _ctx.formatDate(new Date())
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode("Date received")
                        ]),
                        trigger: _withCtx(() => [
                          _createVNode(_component_NrIcon, { name: "calendar-alt" })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "maxDate"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _withDirectives(_createElementVNode("select", {
                              id: "formatReceived",
                              name: "format_received",
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formatReceived) = $event))
                            }, [
                              _hoisted_44,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formats, (format) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: format.id,
                                  value: format.id
                                }, _toDisplayString(format.name), 9, _hoisted_45))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.formatReceived]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.$can('publish', 'Request'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("label", _hoisted_48, [
                              _createTextVNode(" Visibility "),
                              _createVNode(_component_NrTooltip, { position: "right" }, {
                                label: _withCtx(() => [
                                  _createElementVNode("p", { innerHTML: _ctx.visibilityTips }, null, 8, _hoisted_49)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_NrIcon, {
                                    class: "info-circle-icon request-personal-information-icon",
                                    name: "info-circle"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _withDirectives(_createElementVNode("select", {
                                  id: "visibility",
                                  name: "visibility",
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.visibility) = $event))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibilities, (visibility) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: visibility.name,
                                      value: visibility.value,
                                      selected: 
                                  _ctx.defaultVisibility === visibility.value
                                
                                    }, _toDisplayString(visibility.name), 9, _hoisted_52))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.visibility]
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_53
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_NrButton, {
                variant: "filled-neutral",
                class: _normalizeClass(_ctx.createRequestClassnames),
                disabled: _ctx.disabledCreate || _ctx.customFieldsPreview,
                onClick: _ctx.handleCreateRequestByRole
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Make request ")
                ]),
                _: 1
              }, 8, ["class", "disabled", "onClick"])
            ]),
            _hoisted_55
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("aside", _hoisted_57, [
            (!!_ctx.sidebarRequestText)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _ctx.sidebarRequestText
                }, null, 8, _hoisted_58))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_59,
                  _hoisted_60
                ], 64))
          ])
        ])
      ]),
      (_ctx.isSignedIn && !_ctx.customFieldsPreview)
        ? (_openBlock(), _createBlock(_component_DocumentUploadModal, {
            key: 0,
            show: _ctx.showUploadModal,
            account: _ctx.account,
            folders: [],
            folder: _ctx.selectedFolder,
            isModalActive: _ctx.showUploadModal,
            "uploaded-docs": _ctx.uploadedDocuments,
            onOnCloseModal: _cache[39] || (_cache[39] = ($event: any) => (_ctx.toggleUploadModal(false))),
            onOnFileUploadComplete: _ctx.handleDocumentUploads,
            onOnSubmit: _ctx.handleSaveDocumentsToRequest,
            onSelectedFolder: _ctx.handleFolderSelection
          }, null, 8, ["show", "account", "folder", "isModalActive", "uploaded-docs", "onOnFileUploadComplete", "onOnSubmit", "onSelectedFolder"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_NrModal, {
      title: "No email entered",
      secondaryButtonText: "Cancel",
      primaryButtonText: "Continue",
      hasSecondaryButton: true,
      show: _ctx.showNoRequesterEmailModal,
      onOnSecondaryClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.toggleNoRequesterEmailModal(false))),
      onOnCloseClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.toggleNoRequesterEmailModal(false))),
      onOnPrimaryClick: _ctx.createRequest
    }, {
      default: _withCtx(() => [
        _hoisted_61
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"]),
    _createVNode(_component_NrModal, {
      title: "Change perspective",
      primaryButtonText: "Change",
      secondaryButtonText: "Cancel",
      hasSecondaryButton: true,
      show: _ctx.showPerspectiveModal,
      showClose: "",
      onOnCloseClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.togglePerspectiveModal(false))),
      onOnSecondaryClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.togglePerspectiveModal(false))),
      onOnPrimaryClick: _ctx.handlePerspectiveChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NrSelect, {
          options: _ctx.userTypes,
          modelValue: _ctx.selectedUserType,
          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.selectedUserType) = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(" Change Perspective ")
          ]),
          _: 1
        }, 8, ["options", "modelValue"])
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"])
  ]))
}